export default {
  install(Vue: any, options: any) {
    Vue.$virtualearth = Vue.prototype.$virtualearth = {
      virtualearthApiKey: options.virtualearthApiKey,
      virtualearthUrl: 'https://dev.virtualearth.net/REST/v1/Routes/SnapToRoad',

      createRequestObject(url: string, callback: any = null) {
        var xhr = new XMLHttpRequest()

        /* Register callback functions */
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (callback) {
              callback([...xhr.response.resourceSets].pop())
            }
          }
        }

        xhr.responseType = 'json'
        xhr.open('GET', url)
        return xhr
      },

      getDefaultUrl() {
        let url = this.virtualearthUrl
        url += '?key=' + encodeURIComponent(this.virtualearthApiKey)
        url += '&includeTruckSpeedLimit=true&IncludeSpeedLimit=true&speedUnit=MPH&travelMode=driving'
        return url
      },

      send(dataObj: any, callback = null) {
        this.getResult(dataObj, callback)
      },

      getResult(latLngObj: any, callback = null) {
        let url = this.getDefaultUrl()
        /* Add query parameters */
        url += '&points=' + encodeURIComponent(latLngObj.lat) + ',' + encodeURIComponent(latLngObj.lng)
        const xhr = this.createRequestObject(url, callback)
        xhr.send()
      },
    }
  },
}
